<script lang="ts" setup>
    import { useMenuStore } from '@/stores/menu';

    const route = useRoute();
    const menuStore = useMenuStore();
    const { t } = useI18n();

    const opened = ref<string[]>([]);

    const closeDrawer = () => {
        menuStore.mobileMenuDrawer = false;
    };

    const toggleGroup = (itemTitle: string) => {
        const index = opened.value.indexOf(itemTitle);
        if (index > -1) {
            opened.value.splice(index, 1);
        } else {
            opened.value.push(itemTitle);
        }
    };

    watch(
        () => route.name,
        () => {
            if (route.meta.menu) {
                opened.value.push(route.meta.menu as string);
            } else {
                opened.value = [];
            }
        },
        { immediate: true }
    );

    onMounted((): void => {
        console.log('Component app-menuMobile mounted.');
    });
</script>

<template>
    <v-navigation-drawer v-model="menuStore.mobileMenuDrawer" temporary location="start" width="280" class="mobile-drawer">
        <v-list nav class="mobile-menu-list">
            <div v-for="(item, i) in menuStore.navMenuItems" :key="i">
                <!-- Menu group with submenu -->
                <div class="menu-group">
                    <!-- Group header -->
                    <v-list-item class="menu-item parent-item" :class="{ 'active-parent': route.meta.menu === item.title }" @click="toggleGroup(item.title)">
                        <v-list-item-title class="menu-item-text parent-text" :class="{ 'active-text': route.meta.menu === item.title }">
                            {{ t('menu.' + item.title) }}
                        </v-list-item-title>
                        <template v-slot:append>
                            <v-icon size="16" class="chevron-icon">
                                {{ opened.includes(item.title) ? mdiChevronUp : mdiChevronDown }}
                            </v-icon>
                        </template>
                    </v-list-item>

                    <!-- Submenu items -->
                    <div v-if="opened.includes(item.title)" class="submenu-items">
                        <template v-for="subItem in item.subItems" :key="subItem.title">
                            <router-link
                                v-if="subItem.link"
                                :to="{ name: subItem.link, params: subItem.params || {} }"
                                class="submenu-link"
                                @click="closeDrawer"
                            >
                                <v-list-item class="submenu-item" :class="{ 'active-subitem': subItem.link === route.name }">
                                    <v-list-item-title class="submenu-text" :class="{ 'active-text': subItem.link === route.name }">
                                        {{ t('menu.' + subItem.title) }}
                                    </v-list-item-title>
                                </v-list-item>
                            </router-link>
                        </template>
                    </div>
                </div>
            </div>
        </v-list>
    </v-navigation-drawer>
</template>

<style lang="scss" scoped>
    .mobile-menu-list {
        padding: 0 !important;
    }

    .menu-item-text {
        font-size: 14px !important;
        font-weight: 500 !important;
        color: #666 !important;
    }

    .parent-text {
        font-weight: 600 !important;
    }

    .active-text {
        color: rgb(var(--v-theme-tbGreen)) !important;
    }

    .menu-icon {
        color: #666 !important;
    }

    .active-parent {
        .menu-icon {
            color: rgb(var(--v-theme-tbGreen)) !important;
        }
    }

    .chevron-icon {
        color: rgb(var(--v-theme-tbGreen)) !important;
    }

    .submenu-link {
        text-decoration: none !important;
        display: block;
    }

    .submenu-item {
        min-height: 40px !important;
        padding: 8px 16px 8px 32px !important;
        transition: all 0.2s ease;
        border-radius: 0 !important;

        &:hover:not(.active-subitem) {
            background: rgba(var(--v-theme-tbGreen), 0.08) !important;

            .submenu-text {
                color: rgb(var(--v-theme-tbGreen)) !important;
            }
        }
    }

    .active-subitem {
        background: rgba(var(--v-theme-tbGreen), 0.15) !important;

        .submenu-text {
            color: rgb(var(--v-theme-tbGreen)) !important;
        }
    }

    .submenu-text {
        font-size: 13px !important;
        font-weight: 500 !important;
        color: #555 !important;
        text-decoration: none !important;
    }

    .v-theme--dark {
        .mobile-drawer {
            background: #1e1e1e !important;
        }

        .mobile-menu-list {
            background: #1e1e1e !important;
        }

        .menu-item-text {
            color: #e0e0e0 !important;
        }

        .submenu-text {
            color: #ccc !important;
        }

        .menu-icon {
            color: #999 !important;
        }

        .active-text {
            color: rgb(var(--v-theme-tbGreen)) !important;
        }
    }
</style>
